// extracted by extract-css-chunks-webpack-plugin
module.exports = {"icon":"_26dVKr"};